import { create } from 'zustand';

interface TravellerListSelectionState {
  selectedIdsByTenant: Record<string, string[]>;
  setSelectedIds: (tenantId: string, ids: string[]) => void;
}

/**
 * Holds selected travellers on the list page for the current session so the
 * selection is restored when the user navigates away and back. Intentionally
 * not persisted to disk: it lives only for the current app session.
 */
export const useTravellerListSelectionStore =
  create<TravellerListSelectionState>((set) => ({
    selectedIdsByTenant: {},
    setSelectedIds: (tenantId, ids) =>
      set((state) => ({
        selectedIdsByTenant: {
          ...state.selectedIdsByTenant,
          [tenantId]: ids,
        },
      })),
  }));
